import { Box } from '@material-ui/core';
import { formatDateTimeReadable, Merchant, MerchantContract } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { MerchantContractActionType } from '@/components/modules/MerchantDetail/MerchantCompliance/components/MerchantContract/types/MerchantContractActionType';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { Text } from '@/components/shared/components/Text';

export const MerchantContractDialog = ({
  merchantContractAction,
  opened,
  setOpened,
  merchant,
  merchantContract,
}: {
  merchantContractAction: MerchantContractActionType;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  merchant: Merchant;
  merchantContract: MerchantContract;
}) => {
  return (
    <NemuruDialog opened={opened} setOpened={setOpened}>
      <Box mb={4}>
        <Font variant="h3" color="title">
          <Text
            tId={
              MerchantContractActionType.SEE_MERCHANT_CONTRACT_FIELDS
                ? 'MERCHANT_CONTRACT_DATA'
                : 'MERCHANT_CONTRACT_DATA_FROM_CRM'
            }
          />
        </Font>
      </Box>
      {merchantContract.sentDate &&
        merchantContractAction === MerchantContractActionType.SEE_MERCHANT_CONTRACT_FIELDS && (
          <Box mb={4}>
            <Font variant="body2" color="textSecondary">
              <Text
                tId={'MERCHANT_CONTRACT_DATA_TEXT'}
                dynamicDataTexts={[formatDateTimeReadable(merchantContract.sentDate)]}
              />
            </Font>
          </Box>
        )}
      <Box>
        <TextFormField label={'BUSINESS_NAME'} value={merchantContract.businessName} name={merchant.id} />
        <TextFormField label={'CIF'} value={merchantContract.corporateIdNumber} name={merchant.id} />
        <TextFormField label={'ADDRESS'} value={merchantContract.address} name={merchant.id} />
        <TextFormField label={'POSTAL_CODE'} value={merchantContract.postalCode} name={merchant.id} />
        <TextFormField label={'CITY'} value={merchantContract.city} name={merchant.id} />
        <TextFormField label={'PROVINCE'} value={merchantContract.province} name={merchant.id} />
        <TextFormField label={'COUNTRY'} value={merchantContract.country} name={merchant.id} />
        <TextFormField
          label={'COMPANY_MANAGER_FULLNAME'}
          value={`${merchantContract.companyManagerFirstName} ${merchantContract.companyManagerLastName}`}
          name={merchant.id}
        />
        <TextFormField
          label={'COMPANY_MANAGER_DOCUMENT_NUMBER'}
          value={merchantContract.corporateIdNumber}
          name={merchant.id}
        />
        <TextFormField label={'CONTACT_EMAIL'} value={merchantContract.email} name={merchant.id} />
        <TextFormField label={'CONTACT_PHONE_NUMBER'} value={merchantContract.phoneNumber} name={merchant.id} />
      </Box>
    </NemuruDialog>
  );
};
